import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { NoticeBanner } from '@/shared/ui';

interface EventUnsolvedBannerProps {
  dataUpdatedAt: number;
  isError: boolean;
  unsolvedEventCount: number;
}

/**
 * 이벤트 내역 상단 요약 배너.
 * @description
 * - 조회 기간 내 미해결 이벤트 건수를 표시한다.
 * - 건수가 0이면 성공, 1 이상이면 danger variant를 사용한다.
 * - 목록 조회 오류 시 경고 배너로 대체 메시지를 표시한다.
 * @example
 * <EventUnsolvedBanner unsolvedEventCount={1} dataUpdatedAt={Date.now()} isError={false} />
 */
const EventUnsolvedBanner = ({
  dataUpdatedAt,
  isError,
  unsolvedEventCount,
}: EventUnsolvedBannerProps) => {
  if (isError) {
    return (
      <NoticeBannerWrapper
        variant="danger"
        message={<span>목록 로딩 중 일시적인 오류가 발생했습니다.</span>}
        dataUpdatedAt={dataUpdatedAt}
      />
    );
  }

  if (unsolvedEventCount > 0) {
    return (
      <NoticeBannerWrapper
        variant="danger"
        message={
          <span>
            조회 기간에 미해결 이벤트가 <BoldText>{unsolvedEventCount}건</BoldText> 있습니다.
          </span>
        }
        dataUpdatedAt={dataUpdatedAt}
      />
    );
  }

  return (
    <NoticeBannerWrapper
      variant="success"
      message={<span>조회 기간에 미해결 이벤트가 없습니다.</span>}
      dataUpdatedAt={dataUpdatedAt}
    />
  );
};

export default EventUnsolvedBanner;

const BoldText = styled('strong')(
  () => css`
    font-weight: 700;
  `,
);

const NoticeBannerWrapper = styled(NoticeBanner)(
  () => css`
    margin: 16px -4px 0 -4px;
  `,
);
